import React from 'react'
import clsx from 'clsx'
import type { StepStatus } from '../../types/session.types'
import styles from './StepStatusBadge.module.css'

export interface StepStatusBadgeProps {
  status: StepStatus
  className?: string
}

const STEP_STATUS_LABELS: Record<StepStatus, string> = {
  blocked: 'BLOCKED',
  ready: 'READY',
  in_progress: 'IN PROGRESS',
  paused: 'PAUSED',
  done: 'DONE',
  failed: 'FAILED',
  skipped: 'SKIPPED',
  waiting_approval: 'WAITING APPROVAL',
}

export function StepStatusBadge({ status, className }: StepStatusBadgeProps) {
  const label = STEP_STATUS_LABELS[status] ?? status.replace('_', ' ').toUpperCase()

  return (
    <span
      className={clsx(styles.badge, styles[`badge_${status}`], className)}
      aria-label={`Step status: ${label}`}
      data-status={status}
    >
      <span className={clsx(styles.dot, styles[`dot_${status}`])} aria-hidden="true" />
      <span className={styles.label}>{label}</span>
    </span>
  )
}
